<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div>
        <button-component fa-icon="fa-solid fa-trash" background-color="bg-red-500" @click="modal = true" />

        <modal-component v-if="modal" v-model="modal">
            <template #body>
                <div class="sm:flex sm:items-start">
                    <div
                        class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                    >
                        <i class="fa-regular fa-triangle-exclamation text-red-600"></i>
                    </div>
                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg font-medium leading-6 text-secondary" id="modal-title">Wirklich löschen?</h3>
                        <div class="mt-2">
                            <p class="text-sm text-gray-500">
                                Wollen sie diese Anwendung wirklich löschen?
                                <br />
                                <span class="italic">Gelöschte Anwendungen könenn nicht wiederhergestellt werden.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                    @click="deleteEntity"
                >
                    Löschen
                </button>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-secondary bg-white hover:bg-secondary hover:text-white px-4 py-2 text-secondary font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    @click="modal = false"
                >
                    Abbrechen
                </button>
            </template>
        </modal-component>
    </div>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent';
import ModalComponent from '@/components/ModalComponent';

export default {
    name: 'DeleteComponent',
    components: { ModalComponent, ButtonComponent },
    data() {
        return {
            modal: false
        };
    },
    methods: {
        deleteEntity() {
            this.$emit('delete');
            this.modal = false;
        }
    }
};
</script>

<style scoped></style>
